export const CONFIG = {
  10: {
    arrLinkPrefix: ['/purchase/order/detail/', '/sale/customer/order/detail/'],
    mainKey: 'B02_NPo_Status'
  }, //采购单("10","purchaesOrder"),
  11: {
    // arrLinkPrefix: [
    //   '/purchase/change/detail/',
    //   '/sale/customer/change/detail/'
    // ],
    mainKey: 'B02_co_Status'
  }, //采购变更单("11","changeOrder"),
  12: {
    arrLinkPrefix: ['/purchase/receive/detail/'],
    mainKey: 'B02_Ro_Status'
  }, //收货单("12","receiveOrder"),
  13: {
    arrLinkPrefix: ['/purchase/storage/detail/'],
    mainKey: 'B02_Sto_Status'
  }, //入库单("13","storageOrder"),
  14: {
    // arrLinkPrefix: [
    //   '/purchase/receive/return/detail/',
    //   '/sale/delivery/return/detail/'
    // ],
    mainKey: 'B02_Rto_Status'
  }, //退货单("14","returnOrder"),
  15: {
    arrLinkPrefix: ['/purchase/iqc/detail/', '/sale/customer/iqc/detail/'],
    mainKey: 'B02_Verify_Status'
  }, //检验单("15","checkOrder"),
  16: {
    arrLinkPrefix: [
      '/purchase/delivery-change/detail/',
      '/sale/delivery-change/detail/'
    ],
    mainKey: 'B02_Acn_Status'
  }, //交料通知单("16","answerChangeNoticeOrder"),
  17: {
    // arrLinkPrefix: ['/pc/', '/pc/'],
    mainKey: 'B02_ToolsTransfer_Status'
  }, //工装转移单("17","toolingsOrder"),
  18: {
    // arrLinkPrefix: [
    //   '/purchase/supplier/sample/detail/',
    //   '/sale/customer/sample/detail/'
    // ],
    mainKey: 'B02_Sample_Status'
  }, //样品追踪单("18","sampleTrackOrder"),
  19: {
    arrLinkPrefix: ['/purchase/requisition/detail/'],
    mainKey: 'B02_Requisition_Order_Status'
  }, //请购单("19","requisitionOrder"),
  22: {
    arrLinkPrefix: [
      '/purchase/vendorDelivery/detail/',
      '/sale/delivery/detail/'
    ],
    mainKey: 'B02_Dn_Status'
  }, //送货通知单("22","deliveryOrder"),
  23: {
    arrLinkPrefix: ['/purchase/pricing/detail/'],
    mainKey: 'B02_Price_Order_Status'
  }, //核价单("23","pricingOrder"),
  //24: { arrLinkPrefix: ['//', '//'] }, //客户退货单("24","customerReturnOrder"),//阅读状态时使用
  26: {
    // arrLinkPrefix: [
    //   '/purchase/delivery-delay/detail/',
    //   '/sale/delivery-delay/detail/'
    // ],
    mainKey: 'B02_Acn_Status'
  }, // 延迟送货申请单("26","applyDeliveryOrder"),
  27: {
    arrLinkPrefix: [
      '/purchase/iqc/8d-report/detail/',
      '/sale/customer/iqc/8d-report/detail/'
    ],
    mainKey: 'B02_Product8D_Report_Status'
  }, //8D报告("27","verifyP8DReport"),
  28: {
    // arrLinkPrefix: [
    //   '/purchase/inquiry/bid/freightage/detail/',
    //   '/sale/inquiry/bid/freightage/detail/'
    // ],
    mainKey: 'B02_Bid_Status'
  }, //物流竞价单("28","logisticsBiddingOrder"),
  29: {
    // arrLinkPrefix: ['/purchase/supplier/detail/', '/sale/profile/detail/'],
    mainKey: 'B02_vendor_Invite_Status'
  }, //正式供应商("29","compVendor"),
  30: {
    arrLinkPrefix: [
      '/purchase/plan/schedule/detail/',
      '/sale/plan/schedule/detail/'
    ],
    mainKey: ['B02_Sch_Batch_Status', 'B02_Sch_Order_Status']
  }, //排程("30","scheduleOrder"),
  //31: { arrLinkPrefix: ['//', '//'] }, //生产计划("31","productionOrder"),
  32: {
    // arrLinkPrefix: [
    //   '/purchase/iqc/pre-inspect-apply/detail/',
    //   '/sale/customer/pre-inspect-apply/detail/'
    // ],
    mainKey: 'B02_Pre_Verify_Apply_Status'
  }, //预检申请单("32","preverifyApplyOrder"),
  33: {
    arrLinkPrefix: [
      '/purchase/supplier/buyoff-report/detail/',
      '/sale/customer/buyoff-report/detail/'
    ],
    mainKey: 'B02_Material_Report_Status'
  }, //物料准入报告("33","materialOrder"),
  34: {
    // arrLinkPrefix: [
    //   '/purchase/supplier/quality-objectives/detail/',
    //   '/sale/customer/quality-objectives/detail/'
    // ],
    mainKey: 'B02_Quality_Track_Status'
  }, //质量目标追踪("34","qualityTrackOrder"),
  //35: { arrLinkPrefix: ['//', '//'] }, //销售_变更单("35","saleChangeOrder"),
  //36: { arrLinkPrefix: ['//', '//'] }, //出货_出库单("36","outCargoOrder"),// 出货OR出库
  //37: { arrLinkPrefix: ['//', '//'] }, //销售_退货单("37","saleReturnOrder"),
  //38: { arrLinkPrefix: ['//', '//'] }, //销售_对账单("38","saleStatementOrder"),
  //39: { arrLinkPrefix: ['//', '//'] }, //销售_发票单("39","saleInvoiceOrder"),
  40: {
    // arrLinkPrefix: ['/pc/', '/pc/'],
    mainKey: 'B02_Contract_Status'
  }, //合同("40","contractOrder"),
  41: {
    // arrLinkPrefix: [
    //   '/purchase/supplier/qualification/detail/',
    //   '/sale/customer/qualification/detail/'
    // ],
    mainKey: 'B02_Certificates_Status'
  }, //资质("41","certificatesOrder"),
  42: {
    // arrLinkPrefix: ['/purchase/supplier/resource/apply/detail/'],
    mainKey: 'B02_Res_Pool_Status'
  }, //资源申请单("42","resourcePoolOrder"),
  43: {
    arrLinkPrefix: [
      '/purchase/supplier/penalty-notice/detail/',
      '/sale/customer/penalty-notice/detail/'
    ],
    mainKey: 'B02_punish_Status'
  }, //供应商处罚通知单("43","vendorPunishNotice"),
  44: {
    // arrLinkPrefix: ['/purchase/supplier/terminate/detail/'],
    mainKey: 'B02_eliminate_vendor_notice_Status'
  }, //供应商退出通知("44","vendorEliminateNotice"),
  45: {
    arrLinkPrefix: [
      '/purchase/supplier/info-change/detail/',
      '/sale/customer/my-info-change/detail/'
    ],
    mainKey: 'B02_Company_Changed_Status'
  }, //供应商信息变更("45","companyChanged"),
  46: {
    // arrLinkPrefix: [
    //   // '/purchase/inquiry/project/pre-inquiry/detail/',
    //   // '/sale/inquiry/project/pre-inquiry/detail/'
    // ],
    mainKey: 'B02_Prepare_Project_Status'
  }, //项目预询单("46","preInquiry"),
  49: {
    arrLinkPrefix: ['/purchase/plan/tpp/board/', '/sale/plan/tpp/board/'],
    mainKey: 'B02_Direct_Status'
  }, //订单直运看板("49","poDirectDeliveryBoard"),
  50: {
    arrLinkPrefix: [
      '/purchase/inquiry/prod/detail/',
      '/sale/inquiry/prod/detail/'
    ],
    mainKey: 'B02_Inquiry_Status'
  }, //询价("50","inquiryOrder"),
  // 51: { arrLinkPrefix: ['//', '//'] }, //报价("51","quoteOrder"),
  52: {
    arrLinkPrefix: [
      '/purchase/billing/statement/detail/',
      '/sale/billing/statement/detail/'
    ],
    mainKey: 'B02_Reco_Status'
  }, //对账单("52","statementOrder"),
  53: {
    arrLinkPrefix: [
      '/purchase/billing/invoice/detail/',
      '/sale/billing/invoice/detail/'
    ],
    mainKey: 'B02_Inv_Status'
  }, //发票单("53","invoiceOrder"),
  54: {
    arrLinkPrefix: [
      '/purchase/billing/cost/detail/',
      '/sale/billing/cost/detail/'
    ],
    mainKey: 'B02_Cost_Status'
  }, //费用单("54","costsheetOrder"),
  55: {
    arrLinkPrefix: [
      '/purchase/inquiry/bid/detail/',
      '/sale/inquiry/bid/detail/'
    ],
    mainKey: 'B02_Bid_Status'
  }, //竞价单("55","biddingOrder"),
  //56: { arrLinkPrefix: ['//', '//'] }, //竞价_预报价单("56","biddingOrder2"),//公开竞价时，未在供应商列表中的外部企业参与竞价时使用
  //57: { arrLinkPrefix: ['//', '//'] }, //转移单("57","toolsTransfer"),
  58: {
    arrLinkPrefix: [
      '/sale/opportunity-management/lead/detail/',
      '/sale/opportunity-management/lead/detail/'
    ],
    mainKey: 'B02_Opportunity_Status'
  }, //商机("58","opportunityOrder"),
  59: {
    arrLinkPrefix: ['/purchase/inquiry/quote-compare/detail/'],
    mainKey: 'B02_Inquiry_Status'
  }, //比价单("59","priceCompareOrder"),
  60: {
    arrLinkPrefix: [
      '/purchase/payment/advance/detail/',
      '/sale/cust-payment/advance/detail/'
    ],
    mainKey: 'B02_PrepayOrder_status'
  }, //预付款单("60","prepaymentsOrder"),
  61: {
    arrLinkPrefix: [
      '/purchase/payment/apply/detail/',
      '/sale/cust-payment/apply/detail/'
    ],
    mainKey: 'B02_Pay_Apply_status'
  }, //付款申请("61","paymentApply"),//供应商创建“提前付款申请”时也使用这个枚举
  62: {
    arrLinkPrefix: ['/pc/', '/pc/']
  }, //付款计划("62","paymentPlan"),
  //63: { arrLinkPrefix: ['//', '//'] }, //支付申请("63","paymoneyApply"),
  64: {
    arrLinkPrefix: ['/purchase/payment/order/detail/', '/pc/'],
    mainKey: 'B02_ReceiptOrder_Status'
  }, //付款单("64","receiptOrder"),
  //65: { arrLinkPrefix: ['//', '//'] }, //预付退款单("65","prepayReturnOrder"),
  //66: { arrLinkPrefix: ['//', '//'] }, //预付结转单("66","prepayTransferOrder"),
  67: {
    arrLinkPrefix: ['//', '/sale/order/detail/'],
    mainKey: 'B02_So_Status'
  }, //销售订单("67","saleOrder"),
  //68: { arrLinkPrefix: ['//', '//'], mainKey: 'B02_Fnc_Platform_Order_Status' }, //金融票据("68","financialBill"),
  69: {
    arrLinkPrefix: ['/purchase/ecn/detail/', '/sale/ecn/detail/'],
    mainKey: 'B02_Ecn_Report_Status'
  }, //ECN报告("69","ecnReport"),
  70: {
    arrLinkPrefix: ['/purchase/inquiry/inner/detail/'],
    mainKey: 'B02_Inner_Inquiry_Status'
  }, //需求单("70","innerInquiryOrder"),
  71: {
    arrLinkPrefix: [
      '/purchase/inquiry/project/ifb/detail/',
      '/sale/inquiry/project/ifb/detail/'
    ],
    mainKey: 'B02_Project_Bidding_Status'
  }, //项目招标单("71","projectBiddingOrder"),
  //72: { arrLinkPrefix: ['//', '//'] }, //项目投标单("72","projectQuoteOrder"),
  73: {
    arrLinkPrefix: [
      '/purchase/supplier/assessment-report/detail/',
      '/sale/customer/assessment-report/detail/'
    ],
    mainKey: 'B02_Material_Report_Status'
  }, //供应商准入评估报告("73","admissionReport"),
  74: {
    arrLinkPrefix: ['/purchase/mall/introduce-detail/'],
    mainKey: 'B02_Introduce_Status'
  }, //引入单("74","introduceOrder"),
  75: {
    arrLinkPrefix: ['/management/staff/detail/'],
    mainKey: 'B02_Invite_Status_Employee'
  }, //员工档案("75","compEmployee"),
  76: {
    arrLinkPrefix: ['/purchase/receive/acceptance/detail/'],
    mainKey: 'B02_Po_Assets_Acceptance_Status'
  }, //采购验收单("76","accpOrder"),
  77: {
    arrLinkPrefix: [
      '/purchase/receive/sample/detail/',
      '/sale/delivery/sample/detail/'
    ],
    mainKey: 'B02_Dn_Status'
  }, //送样通知
  78: {
    // arrLinkPrefix: ['/purchase/tooling/info/detail/'],
    mainKey: 'B02_ToolsInfo_Status'
  }, //工装档案
  79: {
    // arrLinkPrefix: [
    //   '/purchase/supplier/complaint/detail/',
    //   '/sale/customer/my-complaint/detail/'
    // ],
    mainKey: 'B2b_appeal_order_status'
  }, // 供应商申诉
  82: {
    arrLinkPrefix: [
      '/purchase/supplier/prod-graph/detail/',
      '/sale/customer/prod-graph/detail/'
    ],
    mainKey: 'B2b_prod_graph_change_status'
  }, // 图纸变更
  83: {
    arrLinkPrefix: ['/pc/', '/pc/'],
    mainKey: 'B2b_improve_report_status'
  }, //改善报告("83","improveReport"),
  84: {
    arrLinkPrefix: [
      '/purchase/inquiry/bid-multi/detail/',
      '/sale/inquiry/bid-multi/detail/'
    ],
    mainKey: 'B02_Bid_Status'
  }, //多物料竞价单
  85: {
    arrLinkPrefix: ['/pc/', '/pc/'],
    mainKey: 'B02_Pay_Apply_status'
  }, //提前付款申请
  86: {
    // arrLinkPrefix: [
    //   '/management/basic-data/qualification/detail/',
    //   '/management/basic-data/prod-customer/detail/'
    // ],
    mainKey: 'B02_Certificates_Status'
  }, // 物料资质
  87: {
    arrLinkPrefix: [
      '/purchase/sourcing/detail/',
      '/sale/opportunity-management/potential-customer/detail/'
    ],
    mainKey: 'B02_Invite_Status'
  }, // 潜在供应商
  //90: { arrLinkPrefix: ['//', '//'] }, //服务购买单("90","serviceOrder"),
  91: {
    arrLinkPrefix: [
      '/purchase/billing/debit/detail/',
      '/sale/billing/debit/detail/'
    ],
    mainKey: 'B02_Reco_Status'
  }, //应收折让,
  92: {
    arrLinkPrefix: ['/pc/', '/pc/'],
    mainKey: 'B2b_CableSample_Order_Status'
  }, //索样通知("92","cableSampleOrder"),
  //100: {  }, //潜在供应商("100","potentialVendor"), // 2020-05-06 添加一个类型,在操作日志中，统一处理审批流日志
  101: {
    arrLinkPrefix: ['/pc/', '/pc/'],
    mainKey: 'B02_Certificates_Status'
  }, //问卷调查("101","questionnaire"),
  //103: { arrLinkPrefix: ['//', '//'] }, //物料替代维护("103","alternative"),
  //104: { arrLinkPrefix: ['/management/basic-data/prod/detail/'] } //企业物料("104","compMaterial"),
  //105: { arrLinkPrefix: ['//', '//'] } //企业物料附件("105","compMaterialAttachment"),
  110: {
    arrLinkPrefix: ['/pc/', '/pc/']
  } // 供应商通知
};
